import { yupResolver } from '@hookform/resolvers/yup';

import { passwordTest } from 'lib/yup/helpers';
import * as yup from 'yup';

import { RegistrationFormFields } from './types';

import { EMAIL_PATTERN } from '../../../../../lib/constants';
import { EMAIL_ERROR_MESSAGE } from '../../../../loginForm/constants';

const email = yup
    .string()
    .trim()
    .required()
    .matches(EMAIL_PATTERN, EMAIL_ERROR_MESSAGE);

// Password validation depends on the email domain
const password = yup.string().required().test(passwordTest);

const registrationFormValidationSchema: yup.ObjectSchema<RegistrationFormFields> = yup
    .object({
        email,
        password,
    })
    .required();

export const registrationFormResolver = yupResolver(
    registrationFormValidationSchema,
);
